import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-7" }
const _hoisted_3 = { class: "col-lg-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Course = _resolveComponent("Course")!
  const _component_TablesOfContent = _resolveComponent("TablesOfContent")!
  const _component_CourseInstructor = _resolveComponent("CourseInstructor")!
  const _component_EnrolledStudents = _resolveComponent("EnrolledStudents")!
  const _component_Ratings = _resolveComponent("Ratings")!
  const _component_ManageReviews = _resolveComponent("ManageReviews")!
  const _component_WriteFeedbackHere = _resolveComponent("WriteFeedbackHere")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Course),
    _createVNode(_component_TablesOfContent),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_CourseInstructor)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_EnrolledStudents)
      ])
    ]),
    _createVNode(_component_Ratings),
    _createVNode(_component_ManageReviews),
    _createVNode(_component_WriteFeedbackHere)
  ]))
}